// extracted by mini-css-extract-plugin
export default {"cart-item":"cart_cart-item__Nenqy","cart-total":"cart_cart-total__ddnZG","cart-nothing":"cart_cart-nothing__IeHCm"};